import React from 'react';

const StrapiImage = ({ 
  webpImage, 
  fallbackImage, 
  alt, 
  className = '', 
  style = {},
  strapiUrl,
  ...props 
}) => {
  // Handle both single image (with auto WebP detection) and dual image setup
  if (webpImage && fallbackImage) {
    // Dual image setup - use picture element
    return (
      <picture>
        <source 
          srcSet={`${strapiUrl}${webpImage.url}`} 
          type="image/webp" 
        />
        <img 
          src={`${strapiUrl}${fallbackImage.url}`} 
          alt={alt}
          className={className}
          style={style}
          loading="lazy"
          {...props}
        />
      </picture>
    );
  } else if (fallbackImage) {
    // Single image - use OptimizedImage for auto WebP detection
    const imageSrc = `${strapiUrl}${fallbackImage.url}`;
    return (
      <img 
        src={imageSrc}
        alt={alt}
        className={className}
        style={style}
        loading="lazy"
        {...props}
      />
    );
  }
  
  return null;
};

export default StrapiImage; 